import { primaryColorL1 } from '@calendly/ui/theme'

import { Svg } from './svg'

export const PastMeetingIcon = () => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.5" fill="#CEE6FE" stroke="#CEE6FE" />
    <circle cx="9" cy="9" r="5" fill={primaryColorL1} />
  </Svg>
)
